import { ConnectedSystem } from "./ConnectedSystem";

export default ConnectedSystem;
